import { FC } from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { Divider, Typography } from '@mui/material';
import { UnrealisedFXGainOrLossSubTypeLabels } from 'further-ui/labels';
import { numberToCurrencyString } from 'further-ui/utils';
import { Column } from 'further-ui/components/Layout';
import FormField from 'further-ui/components/FormField';

type Props = {
  recordId: string;
};

const PayablesOrReceivablesHistoryDetail: FC<Props> = ({ recordId }) => {
  const { vehicle } = useLayoutContext();

  const { data: record, isLoading } =
    api.unrealisedFxGainOrLoss.getById.useQuery({
      vehicleId: vehicle?._id ?? '',
      recordId,
    });

  if (isLoading || !vehicle) {
    return null;
  }

  if (!record) {
    return <Typography>Record not found</Typography>;
  }

  return (
    <Column spacing="lg">
      <Divider />
      <FormField label="Date">
        <Typography variant="body2">
          {record.ledgerDate.toReadable()}
        </Typography>
      </FormField>
      <FormField label="Counterparty">
        <Typography variant="body2">
          {record.counterpartyLabel ?? '-'}
        </Typography>
      </FormField>
      <FormField label="Type">
        <Typography variant="body2">
          {UnrealisedFXGainOrLossSubTypeLabels[record.gainOrLossSubType]}
        </Typography>
      </FormField>
      <FormField label="Amount (LCY)">
        <Typography variant="body2">
          {numberToCurrencyString(record.amountLcy, {
            fallback: '-',
            currency: vehicle.baseCurrency,
            negativeInBrackets: true,
          })}
        </Typography>
      </FormField>
      <FormField label="Currency">
        <Typography variant="body2">{record.currencyCode}</Typography>
      </FormField>
    </Column>
  );
};

export default PayablesOrReceivablesHistoryDetail;
